import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "../../api";
import { ApiRoutes } from "../../../constants";
import keys from "./keys";

interface GetEncryptionKeyReturnType {
  publicKey: string | null;
  isLoading: boolean;
}

const useGetEncryptionKey = (): GetEncryptionKeyReturnType => {
  const { data = null, isLoading }: UseQueryResult<string | null, unknown> =
    useQuery(
      [keys.read],
      async () => {
        const { data } = await apiClient.get({ url: ApiRoutes.ENCRYPTION_KEY });
        return (data.publicKey as string).replace(/\\n/g, "\n");
      },
      {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      },
    );

  return { publicKey: data, isLoading };
};

export { useGetEncryptionKey };
